import React, { useEffect, useState } from 'react';
import BenefitItems from './BenefitItem/BenefitItem';

const Benefits = ({
    registrationIdsSelected,
    isActiveFilter
}) => {
    useEffect(() => {
        document.title = "Redech | Itens do benefício"
    }, [])

    return (
        <BenefitItems
            registrationIdsSelected={registrationIdsSelected}
            isActiveFilter={isActiveFilter}
        />
    );
};

export default Benefits;
